import { Car, Loader2, Clock, Printer } from "lucide-react";

// Monitor de Vehículos en Patio — presentacional. Toda la lógica vive en Terminal.jsx.
export const MonitorPatio = ({
  patioOpen, setPatioOpen, patioAutos, patioLoading,
  minutosEstancia, fmtEstancia, dispararEscaneo, reimprimirIngreso,
}) => (
  <div className="border border-white/10 bg-white/[0.02] p-5" data-testid="bloque-monitor">
    <div data-testid="autos-patio">
      <button onClick={() => setPatioOpen((v) => !v)} data-testid="autos-patio-toggle"
        className="w-full flex items-center justify-between mb-3 group">
        <div className="flex items-center gap-2">
          <Car className="h-4 w-4 text-[#FFCC00]" />
          <h3 className="font-display text-sm font-black uppercase tracking-wider">Autos en Patio</h3>
          <span className="text-[10px] font-bold uppercase tracking-wider text-white/40" data-testid="autos-patio-count">{patioAutos.length}</span>
        </div>
        <span className="text-white/40 text-xs group-hover:text-white transition-colors">{patioOpen ? "▲" : "▼"}</span>
      </button>
      {patioOpen && (
        patioLoading ? (
          <div className="p-6 flex justify-center border border-white/10"><Loader2 className="h-4 w-4 animate-spin" /></div>
        ) : patioAutos.length === 0 ? (
          <p className="text-white/30 text-xs py-6 text-center border border-white/10" data-testid="autos-patio-empty">No hay vehículos de estacionamiento general en patio.</p>
        ) : (
          <div className="border border-white/10 divide-y divide-white/5 max-h-72 overflow-y-auto" data-testid="autos-patio-list">
            {patioAutos.map((a) => {
              const mins = minutosEstancia(a.fecha_entrada);
              const largo = mins >= 180; // 3h+ resalta en ámbar
              return (
                <div key={a.id_ticket} data-testid={`patio-row-${a.id_ticket}`}
                  className="w-full flex items-center gap-2 pr-2 hover:bg-white/5 transition-colors duration-150">
                  <button onClick={() => dispararEscaneo(a.folio)} data-testid={`patio-cobro-${a.id_ticket}`}
                    className="flex-1 flex items-center justify-between px-3 py-2.5 text-left min-w-0">
                    <div className="flex items-center gap-3 min-w-0">
                      <span className="font-display font-bold text-sm text-white/90 truncate">{a.folio}</span>
                      {a.placa ? <span className="font-mono text-xs text-white/60 truncate">{a.placa}</span> : null}
                      {a.tipo_vehiculo ? <span className="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 border text-white/50 border-white/20 shrink-0">{a.tipo_vehiculo}</span> : null}
                    </div>
                    <div className="flex items-center gap-1.5 shrink-0">
                      <Clock className={`h-3.5 w-3.5 ${largo ? "text-[#F59E0B]" : "text-white/40"}`} />
                      <span className={`font-mono text-sm font-bold ${largo ? "text-[#F59E0B]" : "text-white/70"}`} data-testid={`patio-estancia-${a.id_ticket}`}>{fmtEstancia(a.fecha_entrada)}</span>
                    </div>
                  </button>
                  <button onClick={() => reimprimirIngreso(a)} title="Reimprimir boleto de ingreso"
                    data-testid={`patio-reimprimir-${a.id_ticket}`}
                    className="btn-hard h-8 w-8 shrink-0 flex items-center justify-center bg-white/5 border border-white/20 hover:border-[#FFCC00] text-white/70 hover:text-[#FFCC00] transition-colors">
                    <Printer className="h-4 w-4" />
                  </button>
                </div>
              );
            })}
          </div>
        )
      )}
    </div>
  </div>
);

export default MonitorPatio;
